import { AppTFunction } from '@retail/app/i18n';
import { dateRangeSchema } from '@retail/calculus/components';
import * as yup from 'yup';

const priceSuggestionPricesSchema = (t: AppTFunction) =>
  yup
    .object({
      salesPrice: yup
        .number()
        .nullable()
        .transform((_, value: string | null) => {
          if (value) {
            return Number((value + '').replace(',', '.'));
          }
          return null;
        })
        .typeError(t('calculus.error.mustBeNumber'))

        .positive(t('calculus.error.mustBeNumber'))
        .required(t('calculus.error.requiredField')),
    })
    .concat(dateRangeSchema(t));

export type PriceSuggestionPricesSchema = yup.InferType<
  ReturnType<typeof priceSuggestionPricesSchema>
>;

export const addPriceSuggestionPricesSchema = (t: AppTFunction) =>
  yup.object({
    items: yup.lazy((value) => {
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const shape = Object.keys(value).reduce((acc, key) => {
          acc[key] = priceSuggestionPricesSchema(t);
          return acc;
        }, {} as Record<string, any>);

        return yup.object().shape(shape);
      }

      return yup.object();
    }),
  });

export type AddPriceSuggestionPricesSchema = {
  items: Record<string, yup.InferType<ReturnType<typeof priceSuggestionPricesSchema>>>;
};
